var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-exchange-detail',{staticClass:"pt-integral-exchange-detail__page",attrs:{"operation":_vm.operation}})}
var staticRenderFns = []

export { render, staticRenderFns }